import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M480-40 184-262q-11-8-17.5-21t-6.5-27v-510q0-24 18-42t42-18h520q24 0 42 18t18 42v510q0 14-6.5 27T776-262L480-40Zm-42-320 226-226-43-42-184 184-99-99-42 42 142 141Z"
  })
}), "BeenhereFilled");